import {
  DateParser,
  ErrorState,
  formatNumber,
  IconTitle,
  InformationBlock,
  Loading
} from '@dec/shared';
import { t } from 'i18next';
import {
  Bank2,
  Calendar2,
  Cash,
  CurrencyExchange,
  FileEarmarkText,
  Info
} from 'react-bootstrap-icons';

import { TaxReturnCard } from '../../tax-returns/components/TaxReturnCard';
import { usePayment } from '../hooks/usePayment';

interface PaymentCardProps {
  id: string;
}

export function PaymentCard({ id }: PaymentCardProps) {
  const { data, isLoading, error } = usePayment(id);

  if (isLoading) {
    return <Loading />;
  }

  if (error) {
    return <ErrorState />;
  }

  const alertClassName: string =
    data?.status == 'pending' ? 'warning' : data?.status == 'reconciled' ? 'success' : 'danger';

  return (
    <div className="row">
      <div className="col-12 col-md-5 col-lg-4">
        <div className={`alert alert-${alertClassName} text-center fw-bold`}>
          {t(`common.taxreturn-status.${data?.status}`)}
        </div>

        <TaxReturnCard id={data?.taxReturnId ?? ''} />
      </div>
      <div className="col-12 col-md-7 col-lg-8">
        <div className="card h-100">
          <div className="card-header bg-soft text-primary">
            <IconTitle
              title={t(`payments.declaration`)}
              icon={CurrencyExchange}
              subtitle={data?.paymentNumber}
            />
          </div>
          <div className="card-body py-4 px-4">
            <div className="row">
              <div className="col-12 col-md-6">
                <InformationBlock
                  title={t('common.label.paymentMethod')}
                  value={data?.paymentMethod?.name}
                  icon={FileEarmarkText}
                />
              </div>
              <div className="col-12 col-md-6">
                <InformationBlock
                  title={t('taxpayer-payments.label.date-payment')}
                  value={DateParser.toString(data?.paymentDate)}
                  icon={Calendar2}
                />
              </div>
              <div className="col-12 col-md-6">
                <InformationBlock
                  title={t('taxpayer-payments.label.swiftNumber')}
                  value={data?.swift}
                  icon={Info}
                />
              </div>
              <div className="col-12 col-md-6">
                <InformationBlock
                  title={t('common.label.currency')}
                  value={data?.currency?.name}
                  icon={Cash}
                />
              </div>
              <div className="col-12 col-md-6">
                <InformationBlock
                  title={t('taxpayer-payments.label.amountTaxReturn')}
                  value={formatNumber(data?.amount)}
                  icon={CurrencyExchange}
                />
              </div>
            </div>
          </div>
        </div>

        {/* payment transaction */}
        {data?.paymentTransaction !== null && (
          <div className="card h-100">
            <div className="card-header bg-soft text-primary">
              <IconTitle title={t(`payments.transaction`)} icon={Bank2} />
            </div>
            <div className="card-body py-4 px-4">
              <div className="row">
                <div className="col-12 col-md-6">
                  <InformationBlock
                    title={t('taxpayer-payments.label.date-payment')}
                    value={DateParser.toString(data?.paymentTransaction?.date)}
                    icon={Calendar2}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <InformationBlock
                    title={t('taxpayer-payments.label.amountTaxReturn')}
                    value={formatNumber(data?.paymentTransaction?.amount)}
                    icon={CurrencyExchange}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
